var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 110,
    viewBox: "0 0 299 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 107.5V7.50009C17.5 5.50012 32.8 10.2001 38 11.0001C44.5 12.0001 90 31.0001 100 33.5001C116 40.5001 135.15 43.8618 154.5 51.5001C173.5 59.0001 196 60.5001 196 60.5001H293V107.5H6Z",
    fill: "url(#paint0_linear_126_8118)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6C59.5691 10.3741 62.555 21.8282 92.1981 31.4317C127.64 42.9137 151.727 53.0693 193.46 60.3957C193.46 60.3957 249.37 60.3957 291 60.3957",
    stroke: "url(#paint1_linear_126_8118)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 4,
    fill: "#3E65EF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.5,
    stroke: "#3E65EF",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 60,
    r: 4,
    fill: "#1CD774"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 60,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 60,
    r: 4,
    fill: "#1CD774"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 60,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 34,
    r: 4,
    fill: "#3E65EF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 34,
    r: 5.5,
    stroke: "#3E65EF",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 109.5V16",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 109.5V38",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197 109.5V71",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293 109.5V70.5",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_8118",
    x1: 149.593,
    y1: 7.00879,
    x2: 149.593,
    y2: 107.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E65EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_126_8118",
    x1: 256,
    y1: 72.5,
    x2: 6.29699,
    y2: 6.42677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00229167,
    stopColor: "#1CD774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428803,
    stopColor: "#BDFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629891,
    stopColor: "#3E65EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E65EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart1);
export default __webpack_public_path__ + "static/media/chart1.53e0a39da348590e08f3f34c9700c858.svg";
export { ForwardRef as ReactComponent };